import { Box, Chip, Typography } from '@mui/material';
import { ToolGroupProps } from './tool-group.interface';

export function ToolGroupComponent({
  title,
  tools,
  emptyLabel,
  selectedTools,
  disabled,
  onToggle,
  pendingName = null,
  message = null,
}: ToolGroupProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="subtitle2">{title}</Typography>
      {message ? (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      ) : tools.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {emptyLabel}
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {tools.map((tool) => {
            const isSelected = selectedTools.has(tool.name);

            return (
              <Chip
                key={tool.name}
                label={tool.name}
                onClick={() => {
                  onToggle(tool.name);
                }}
                disabled={disabled}
                color={isSelected ? 'success' : 'default'}
                variant={isSelected ? 'filled' : 'outlined'}
                sx={{ opacity: pendingName === tool.name ? 0.6 : 1 }}
              />
            );
          })}
        </Box>
      )}
    </Box>
  );
}
